<template>
  <div id="app">
    <link
      rel="stylesheet"
      href="https://use.fontawesome.com/releases/v5.2.0/css/all.css"
      integrity="sha384-hWVjflwFxL6sNzntih27bfxkr27PmbbK/iSvJ+a4+0owXq79v+lsFkW54bOGbiDQ"
      crossorigin="anonymous"
    >
    <navabar></navabar>
    <div class="main-container p-0">
      <router-view></router-view>
    </div>
  </div>
</template>

<script lang="js">
import navabar from './helpers/AppBar'
// import rss from './helpers/RSS'
export default {
  name: 'app',
  components: {
    navabar
    // rss
  },
  mounted () {
    if (this.$route.name === 'home' && !this.$route.params.ciudad) {
      this.$router.push({ name: 'home', params: { ciudad: 'juarez' } })
    }
  // this.$router.push({name: 'home', params: {ciudad: 'juarez'}})
  }
}
</script>

<style lang="scss">
body,
html,
#app {
  margin: 0;
  // height: 100%;
  // background: rgb(88, 47, 50);
  background: white;
}

#app {
  font-family: "brandon_grotesquelight_italic", sans-serif;
  color: aliceblue;
  // background-image: url("./assets/bg.png");
  // background-size: 23%;
  // background-repeat: repeat;
  .main-container {
    // background: #582f32;
    // background: black;
    // -webkit-box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3),
    //   0 0 40px rgba(0, 0, 0, 0.1) inset;
    // -moz-box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3),
    //   0 0 40px rgba(0, 0, 0, 0.1) inset;
    // box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3), 0 0 40px rgba(0, 0, 0, 0.1) inset;
    &:before,
    &:after {
      // content: "";
      // position: absolute;
      // z-index: -1;
      // -webkit-box-shadow: 0 0 20px rgba(0, 0, 0, 0.8);
      // -moz-box-shadow: 0 0 20px rgba(0, 0, 0, 0.8);
      // box-shadow: 0 0 20px rgba(0, 0, 0, 0.8);
      // top: 10px;
      // bottom: 10px;
      // left: 0;
      // right: 0;
      // -moz-border-radius: 100px / 10px;
      // border-radius: 100px / 10px;
    }
    &:after {
      // right: 10px;
      // left: auto;
      // -webkit-transform: skew(8deg) rotate(3deg);
      // -moz-transform: skew(8deg) rotate(3deg);
      // -ms-transform: skew(8deg) rotate(3deg);
      // -o-transform: skew(8deg) rotate(3deg);
      // transform: skew(8deg) rotate(3deg);
    }
  }
}
.border-xp {
  // border-bottom: 3px solid #ed5a24;
}
.border-xp-doble {
  // border-bottom: 3px solid #ed5a24;
  // border-top: 3px solid #ed5a24;
}
</style>
